export default __webpack_public_path__ + "static/media/icon-edit-green.b62a24e6.svg";